module.exports = __webpack_public_path__ + "img/ic-sin-gastos.64f2e099.svg";